import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import User from '../../assets/user.png';
import InboxMessageItem from '../../components/InboxMessageItem';
import InboxMessageItem2 from '../../components/InboxMessageItem2';
import '../../styles/chatStyle.css';
import { useAxios } from '../../utils/hook/useAxios';
import { useUser } from '../../utils/hook/UserContext';
import socket from '../../utils/socket';

function ChatBoxReservation() {
  const [conversations, setConversations] = useState([]);
  const [Message, setMessage] = useState('');
  const axios = useAxios();
  const { reservationId } = useParams();
  const { user: authUser, loading, isAuthenticated } = useUser();

  const messagesEndRef = useRef(null);
  const conversationsRef = useRef([]);

  /* ── auto-scroll ── */
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [conversations]);

  /* ── sync ref ── */
  useEffect(() => {
    conversationsRef.current = conversations;
  }, [conversations]);

  /* ── socket : rejoindre la room de cette réservation ── */
  useEffect(() => {
    if (!reservationId) return;

    const handleNewMessage = (msg) => {
      const enriched = {
        ...msg,
        Reservation: conversationsRef.current[0]?.Reservation,
      };
      setConversations((prev) => {
        // PK = conversationId, pas id
        if (prev.some((c) => c.conversationId === msg.conversationId)) return prev;
        return [...prev, enriched];
      });
    };

    const joinRoom = () => {
      socket.emit('join-room', reservationId);
    };

    if (socket.connected) {
      joinRoom();
    } else {
      socket.connect();
      socket.once('connect', joinRoom);
    }

    socket.on('new-message', handleNewMessage);

    return () => {
      socket.emit('leave-room', reservationId);
      socket.off('new-message', handleNewMessage);
      socket.off('connect', joinRoom);
    };
  }, [reservationId]);

  /* ── chargement initial des messages ── */
  useEffect(() => {
    if (!reservationId) return;
    axios
      .get('/conversations/' + reservationId)
      .then((r) => {
        if (r.data) setConversations(r.data);
      })
      .catch((e) => console.error(e));
  }, [reservationId]);

  /* ── envoi d'un message ── */
  function handleSendMessage() {
    if (!Message.trim()) return;
    const msgText = Message;
    setMessage('');
    axios
      .post('/conversations', {
        authorDriverRole: 1, // guest = role 1
        driversId: authUser?.id, // ID du sender courant
        sentTime: new Date(),
        reservationId: conversations[0]?.reservationId || reservationId,
        message: msgText,
      })
      .then(() => {
        axios
          .get('/conversations/' + conversations[0]?.reservationId)
          .then((r) => setConversations(r.data))
          .catch(console.error);
        axios
          .post('/notifications', {
            Titre: 'Nouveau message',
            message: `${authUser?.firstName} vous a envoyé un message`,
            userId: authUser?.id,
          })
          .catch(console.error);
      })

      .catch((e) => {
        console.log(e);
        setMessage(msgText);
      });
  }

  /* ── UI ── */
  return (
    <section className="mb-3">
      <div className="container">
        <div className="msg-header d-flex justify-content-between">
          <div className="container1">
            <img src={User} className="msgimg img-chat" alt="avatar" />
            {conversations.length > 0 && (
              <div className="active">
                <p>
                  {conversations[0].UserProfile?.firstName} {conversations[0].UserProfile?.lastName}
                </p>
              </div>
            )}
          </div>
          <i
            className="bi bi-fullscreen h2 p-1"
            data-bs-toggle="modal"
            data-bs-target="#fullScreen"
          ></i>

          {/* Modal plein écran */}
          <div
            className="modal fade"
            id="fullScreen"
            tabIndex="-1"
            aria-labelledby="fullScreenLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-fullscreen">
              <div className="modal-content">
                <div className="modal-header">
                  <i
                    className="bi bi-fullscreen-exit h2"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></i>
                </div>
                <div className="modal-body">
                  <div className="chat-page">
                    <div className="msg-inbox">
                      <div className="chats">
                        <div className="msg-page annonce-list">
                          {conversations.map((conv) =>
                            conv.authorDriverRole === '0' || conv.authorDriverRole === 0 ? (
                              <InboxMessageItem key={conv.conversationId} data={conv} />
                            ) : (
                              <InboxMessageItem2 key={conv.conversationId} data={conv} />
                            )
                          )}
                          <div ref={messagesEndRef} />
                        </div>
                      </div>
                      <div className="msg-bottom">
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Taper un message..."
                            value={Message}
                            onChange={(e) => setMessage(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') handleSendMessage();
                            }}
                          />
                          <span className="input-group-text send-icon" onClick={handleSendMessage}>
                            <i className="bi bi-send"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Vue principale */}
        <div className="chat-page">
          <div className="msg-inbox">
            <div className="chats">
              <div className="msg-page annonce-list">
                {conversations.map((conv) =>
                  conv.authorDriverRole === '0' || conv.authorDriverRole === 0 ? (
                    <InboxMessageItem key={conv.conversationId} data={conv} />
                  ) : (
                    <InboxMessageItem2 key={conv.conversationId} data={conv} />
                  )
                )}
                <div ref={messagesEndRef} />
              </div>
            </div>
            <div className="msg-bottom">
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Taper un message..."
                  value={Message}
                  onChange={(e) => setMessage(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') handleSendMessage();
                  }}
                />
                <span className="input-group-text send-icon" onClick={handleSendMessage}>
                  <i className="bi bi-send"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ChatBoxReservation;
